// extracted by mini-css-extract-plugin
export default {"pencilBannerSlot":"PencilBrazeBanner_pencilBannerSlot__L492g"};